module.exports = __webpack_public_path__ + "static/media/logo_credifoz.8a84bcae.svg";